import { useEffect } from 'react';
import { useActivityImageDisplaySource } from 'hooks/useActivityImageDisplaySource';

interface ActivityInstructionImageProps {
  activityId: string;
  url?: string;
  filePath?: string;
  alt: string;
  imgClassName?: string;
  onLoad?: () => void;
  onError?: () => void;
}

/**
 * Renders an activity instruction image: direct `url` for external images,
 * or presigned read URL from API when `filePath` (R2 key) is set.
 */
export default function ActivityInstructionImage({
  activityId,
  url,
  filePath,
  alt,
  imgClassName,
  onLoad,
  onError
}: ActivityInstructionImageProps) {
  const { displayUrl, error } = useActivityImageDisplaySource(
    activityId,
    url,
    filePath
  );

  useEffect(() => {
    if (error) onError?.();
  }, [error, onError]);

  if (!displayUrl) {
    return null;
  }

  return (
    <img
      src={displayUrl}
      alt={alt}
      className={imgClassName}
      onLoad={onLoad}
      onError={() => onError?.()}
    />
  );
}
